// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2036":"d9282c35d110f098aa99","2415":"0bdeb05e8c9ecd5513ef","6286":"f61c742bbdb4257a80fe","8951":"f25efe5e1f077c135c8b"}[chunkId] + ".css";
};